import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FaBuilding } from 'react-icons/fa';
import { BeatLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import Link from '../../atoms/layout/Link';
import ModalConfirm from '../ModalConfirm';
import useModal from '../../../hooks/useModal';
import { LOGOUT } from '../../../api/apiAuth';
import { GET_INMUEBLES_BY_USER } from '../../../api/apiInmuebles';
import { useSession } from '../../../context/SessionContext';
import { userLinks } from '../../../data/userLinks';
import { adminLinks } from '../../../data/adminLinks';
import { staffLinks } from '../../../data/staffLinks';
import { supervisorLinks } from '../../../data/supervisorLinks';

const MenuLinks = ({ onClose }) =>  {
    const navigate = useNavigate();
    const { user, setUser } = useSession();
    const [loading, setLoading] = useState();
    const [inmuebles, setInmuebles] = useState();
    const { open: openOut, close: closeOut, isOpen: isOpenOut } = useModal();

    const getInmuebles = useCallback ( async (id) => {
        if (!id) return;
        setLoading(true);
        try {
            const inmueblesData = await GET_INMUEBLES_BY_USER(id);
            setInmuebles(inmueblesData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (user?.id && user?.role === "Resident") {
            getInmuebles(user.id);
        }
    }, [user?.id, user?.role, getInmuebles]);

    const inmueblesLinks = inmuebles?.map((inmueble) => ({
        path: `/${user.id}/${inmueble?.id}`, label: `${inmueble?.name}`, icon:FaBuilding
    }));

    const handleSingOut = async () => {
        try {
            await LOGOUT();
            setUser(null);
            setInmuebles(null);
            toast.success("Sesión cerrada exitosamente");
            navigate("/login");
        } catch (error) {
            console.error(error);
            toast.error("Error al cerrar sesión");
        }
    };

    let links;

    if (user?.role === "GeneralAdmin") {
        links = adminLinks;
    } else if (user?.role === "Resident") {
        links = [...userLinks, ...(inmueblesLinks || [])];
    } else if (user?.role === "Administrative") {
        links = supervisorLinks;
    } else if (user?.role === "Staff") {
        links = staffLinks;
    }

    if (loading) return <div className='w-full h-full flex justify-center items-center'> <BeatLoader color='red' /> </div>

    return (
        <div className='h-full flex flex-col justify-between'>
            {!links ?
                    <div className='w-full h-12 flex justify-center items-center'>
                        <BeatLoader color='red' />
                    </div>
                :
                    <div className='grid gap-1'>
                        {links?.map((link, index) =>
                            <Link href={link.path} label={link.label} onClose={onClose} key={index} Icon={link.icon} />
                        )}
                    </div>
            }
            <button onClick={openOut} className='w-full p-2 text-center text-white ml-2 md:rounded-lg hover:bg-gray-500'> Cerrar sesión</button>
            {isOpenOut &&
                <ModalConfirm onClose={closeOut} onConfirm={handleSingOut} />
            }
        </div>
    )
};

export default MenuLinks;